import {SET_STEP} from "../system/types";

export const SEARCH_ADDRESS = 'SEARCH_ADDRESS';
export const SET_ADDRESS = 'SET_ADDRESS';
export const FETCH_FAILED = 'FETCH_FAILED';

export interface AddressType {
    accumulationRegister: string
    postCode: string
    unitNo: string
    floorNo: string
    buildingName: string
    buildingStreetNo: string
    streetName: string
    streetNo: string
    state: string
    district: string
    districtCode: string
    country: string
    addressLine: string
    addressLine1: string
    addressLine1Masked: string
    addressLine2: string
    addressLine3: string
    addressLine4: string
    addressType: string
}

interface SetAddress {
    type: typeof SET_ADDRESS
    addresses: []
}

interface FetchFailed {
    type: typeof FETCH_FAILED
    message: string
}

export type ActionType = SetAddress | FetchFailed;

